import {useContext} from 'react';
import {GuestContext} from './guest';

function useSchema() {
  const context = useContext(GuestContext);
  if (context === undefined) {
    throw new Error('useReservation must be used within a GuestProvider');
  }
  return context;
}

export {useSchema};
